/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSubtract } from '../../factoriesNumber.js';
export var subtractDependencies = {
  typedDependencies,
  createSubtract
};